import permissionApi from '../api/permission';
import Setting from '../setting';

// 动态路由
export default {
  async init(router, pages, layout) {
    if (pages == null) {
      pages = {};
    }

    let res = await permissionApi.queryRouter();

    // 自定义页面数据处理
    res.forEach(permission => {
      if (permission.isCustomPage) {
        permission.url += '?id=' + permission.customPageID;
        if (permission.customPage.customPageTemplate) {
          permission.templateUrl = 'template/' + permission.customPage.customPageTemplate.substr(0, 1).toLowerCase() + permission.customPage.customPageTemplate.substr(1) + '.vue';
        }
      }
    });

    let allPer = res;
    let topPer = allPer.filter(p => p.parentID == null);
    let routes = [
      {
        path: '*',
        name: '404',
        meta: {
          title: '404'
        },
        component: resolve => {
          require([], () => {
            resolve(pages['system/error/404.vue']);
          });
        }
      },
      {
        path: '/',
        redirect: {
          name: 'login'
        },
        component: layout,
        children: []
      }
    ];
    for (let i = 0; i < topPer.length; i++) {
      if (!(topPer[i].templateUrl || '').trim()) {
        topPer[i] = PermissionDeep(topPer[i], allPer);
      } else {
        // 一级菜单
        let parent = routes.find(element => {
          return element.path === '/';
        });
        let item = topPer[i];
        let url = item.url.split('?')[0];
        let data = {};
        if (item.url.split('?').length > 1) {
          item.url
            .split('?')[1]
            .split('&')
            .forEach(item => {
              if (item.split('=').length > 1 && item.split('=')[0].length > 0) {
                data[item.split('=')[0]] = item.split('=')[1];
              }
            });
        }
        let node = {
          id: item.id,
          path: url.split('/').pop(),
          name: url.replace(/\//g, '-'),
          meta: {
            auth: false,
            title: getNameI18n(item),
            description: getDescI18n(item),
            data,
            cache: true //item.isMenu
          },
          component: resolve => {
            require([], () => {
              resolve(pages[item.templateUrl]);
            });
          }
        };

        parent.children.push(node);
      }
    }
    buildPermission(pages, topPer, routes, layout, null);

    routes.forEach(route => {
      router.addRoute(route);
    });

    return routes;
  }
};

function buildPermission(pages, perArry, routes, layout, parent) {
  perArry.forEach(item => {
    let node;
    if (item.parentID == null) {
      if (!(item.templateUrl || '').trim()) {
        node = {
          id: item.id,
          pId: item.parentID,
          path: '/' + item.url.split('/').pop(),
          name: item.url.replace('app.', '').replace(/\./g, '-'),
          meta: {
            auth: false
          },
          component: layout
        };
        routes.push(node);
      }
    } else {
      // 获取参数
      let url = item.url.split('?')[0];
      let data = {};
      if (item.url.split('?').length > 1) {
        item.url
          .split('?')[1]
          .split('&')
          .forEach(item => {
            if (item.split('=').length > 1 && item.split('=')[0].length > 0) {
              data[item.split('=')[0]] = item.split('=')[1];
            }
          });
      }
      node = {
        id: item.id,
        pId: item.parentID,
        path: url.split('/').pop(),
        name: url.replace(/\//g, '-'),
        meta: {
          auth: false,
          title: getNameI18n(item),
          description: getDescI18n(item),
          data,
          cache: true //item.isMenu
        },
        component: resolve => {
          require([], () => {
            resolve(pages[item.templateUrl]);
          });
        }
      };
      if (parent == null) {
        parent = routes.find(p => p.id == item.parentID);
      }
      if (parent != undefined) {
        if (parent.children == null) {
          parent.children = [];
        }

        if (parent.pId != null) {
          let backup = parent;
          parent = routes.find(p => p.id == parent.pId);
          node.path = url.split('/').splice(1).join('/');
          parent.children.push(node);
          parent = backup;
        } else {
          parent.children.push(node);
        }
      }
    }

    if (item.sonPer != null) {
      buildPermission(pages, item.sonPer, routes, layout, node);
    }
  });

  return routes;
}

function PermissionDeep(per, perArry) {
  let sonPerArry = perArry.filter(p => p.parentID == per.id);
  if (sonPerArry.length > 0) {
    per['sonPer'] = sonPerArry;
    for (let i = 0; i < sonPerArry.length; i++) {
      sonPerArry[i] = PermissionDeep(sonPerArry[i], perArry);
    }
  }
  return per;
}

// 获取多语言名称
function getNameI18n(item) {
  if (Setting.layout.showNotice) {
    let key = 'Permission_' + item.url.split('?')[0];
    let text = window.$t(key);
    if (text == key) {
      return item.name;
    } else {
      return text;
    }
  } else {
    return item.name;
  }
}

// 获取多语言描述
function getDescI18n(item) {
  if (Setting.layout.showNotice) {
    let key = 'Permission_' + item.url.split('?')[0] + '_SubName';
    let text = window.$t(key);
    if (text == key) {
      return item.subName;
    } else {
      return text;
    }
  } else {
    return item.subName;
  }
}
